import { Component, Input } from '@angular/core';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';

@Component({
  selector: 'app-work-and-rest-user-template',
  templateUrl: './work-and-rest-user-template.component.html',
  styleUrls: ['./work-and-rest-user-template.component.scss'],
  standalone: false,
})
export class WorkAndRestUserTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;
  dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;
}
